import { useAtomValue } from 'jotai';
import { selectedBusinessUnitIdAtom } from '@/stores/business-unit.store';
import { usePermissions } from '@/hooks/use-permissions';
import { productRecommendationService } from '@/services/product-recommendation.service';
import { RecommendationSettings } from './recommendation-settings';
export function RecommendationTab() {
  const scope = useAtomValue(selectedBusinessUnitIdAtom) ?? '';
  const { can, isLoading } = usePermissions();
  if (isLoading) return <p className='p-5'>Loading permissions…</p>;
  if (!can('view', 'products')) return <p className='p-5'>You do not have access to product recommendations.</p>;
  return <RecommendationSettings key={scope} client={productRecommendationService} scope={scope} canEdit={can('edit', 'products')} />;
}
